"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = require("prop-types");
var _airbnbPropTypes = require("airbnb-prop-types");
var _propTypes2 = require("@agillic/prop-types");
var _icon = _interopRequireDefault(require("../icon/icon.presenter"));
var _spinner = _interopRequireDefault(require("../spinner/spinner.presenter"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ActionButton = function ActionButton(_ref) {
  var _ref$buttonType = _ref.buttonType,
    buttonType = _ref$buttonType === void 0 ? 'regular' : _ref$buttonType,
    icon = _ref.icon,
    children = _ref.children,
    isDisabled = _ref.isDisabled,
    isPending = _ref.isPending,
    customOnClickHandler = _ref.customOnClickHandler,
    isSmall = _ref.isSmall,
    tooltip = _ref.tooltip,
    iconNamespace = _ref.iconNamespace,
    isOn = _ref.isOn,
    uniqueId = _ref.uniqueId,
    onClick = _ref.onClick;
  return _react.default.createElement("button", {
    className: (0, _classnames.default)('agillicActionButton', buttonType, {
      pending: isPending,
      small: isSmall,
      on: isOn,
      icon: icon
    }),
    type: "button",
    onClick: customOnClickHandler || function () {
      return onClick();
    },
    disabled: isDisabled,
    title: tooltip,
    "data-testid": uniqueId
  }, icon && !isPending && _react.default.createElement(_icon.default, {
    name: icon,
    namespace: iconNamespace
  }), isPending && _react.default.createElement(_spinner.default, {
    size: isSmall ? 12 : 14,
    color: buttonType === 'regular' ? 'white' : 'lightGrey',
    lightBackdrop: 0.25,
    isExtraThin: true
  }), children && _react.default.createElement("span", {
    className: "caption"
  }, children));
};
ActionButton.propTypes = {
  customOnClickHandler: (0, _airbnbPropTypes.and)([(0, _propTypes2.forbiddenBy)('onClick'), _propTypes.func]),
  onClick: (0, _airbnbPropTypes.and)([(0, _propTypes2.forbiddenBy)('customOnClickHandler'), _propTypes.func]),
  buttonType: (0, _propTypes.oneOf)(['regular', 'secondary', 'inline']),
  icon: _propTypes.string,
  iconNamespace: _propTypes.string,
  tooltip: _propTypes.string,
  children: _propTypes.node,
  isDisabled: _propTypes.bool,
  isPending: _propTypes.bool,
  isSmall: _propTypes.bool,
  isOn: _propTypes.bool,
  uniqueId: _propTypes.string
};
var _default = ActionButton;
exports.default = _default;